import { EnvelopeRegularV6 } from "@shared/v2/Icomoon";
import TextLink from "@shared/v2/TextLink";

import IntegrationDiagram from "../IntegrationDiagram";

interface LivePanelProps {
  className: string;
}

const LivePanel = ({ className }: LivePanelProps) => (
  <div data-cy="connect-services-step-4" className={className}>
    <h1 className="tw-m-0 tw-text-center tw-text-28d tw-font-normal tw-text-gray-75">
      Integration is Now Live
    </h1>

    {/* Figma: 32px between every section. PANEL_BASE gives 16px, so each
        section adds the other 16px itself. The sub-head and the body sit only
        8px apart, so they share this wrapper rather than being siblings of the
        heading — the 8px is the wrapper's own gap, not PANEL_BASE's. The 8px
        padding narrows the body to the 536px the design wraps its lines at. */}
    <div className="tw-mt-[16px] tw-flex tw-flex-col tw-gap-[8px] tw-px-[8px]">
      <div className="tw-flex tw-items-center tw-justify-center tw-gap-[8px]">
        <EnvelopeRegularV6 size="xl" className="tw-block tw-text-gray-75" />
        <span className="tw-text-18d tw-font-normal tw-text-gray-75">Check Your Email!</span>
      </div>

      <div className="tw-text-center tw-text-14d tw-font-normal tw-text-gray-75">
        <p className="tw-m-0">
          Your transactions can automatically be “activated” for your customers to receive
          complimentary Connect Services moving support 21 days before their close date.
        </p>
        <p className="tw-mb-0 tw-mt-[20px]">
          Note: You can manage this automation from the{" "}
          {/* @ts-expect-error props */}
          <TextLink href="/add_ons">Add Ons</TextLink> page.
        </p>
      </div>
    </div>

    <div className="tw-mt-[16px]">
      <IntegrationDiagram status="live" />
    </div>
  </div>
);

export default LivePanel;
